webpackJsonp([112875127094159],{

/***/ 1160:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/architecture.1d240476.png";

/***/ }),

/***/ 1161:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/frame-mock.7871a2f6.png";

/***/ }),

/***/ 1164:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ss1.20fc8ff8.png";

/***/ }),

/***/ 1165:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ss2.31667357.png";

/***/ }),

/***/ 1166:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ss3.8ab9011c.png";

/***/ }),

/***/ 1167:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ss4.c34210da.png";

/***/ }),

/***/ 1168:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ss5.3910c761.png";

/***/ }),

/***/ 1169:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ss6.7593db43.png";

/***/ }),

/***/ 1170:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ss7.b71426a9.png";

/***/ }),

/***/ 1171:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ss8.7722fd89.png";

/***/ }),

/***/ 1172:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ss9.cdf65b29.png";

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactImages = __webpack_require__(112);
	
	var _reactImages2 = _interopRequireDefault(_reactImages);
	
	var _gallery = __webpack_require__(136);
	
	var _gallery2 = _interopRequireDefault(_gallery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var laminarPage = function laminarPage(_ref) {
	    var children = _ref.children,
	        location = _ref.location;
	
	    var mockImg = __webpack_require__(1161);
	    var architectureImg = __webpack_require__(1160);
	    var screenshots = [{ src: __webpack_require__(1164) }, { src: __webpack_require__(1165) }, { src: __webpack_require__(1166) }, { src: __webpack_require__(1167) }, { src: __webpack_require__(1168) }, { src: __webpack_require__(1169) }, { src: __webpack_require__(1170) }, { src: __webpack_require__(1171) }, { src: __webpack_require__(1172) }];
	    return _react2.default.createElement(
	        'div',
	        { className: 'portofolio-project-wrapper ' },
	        _react2.default.createElement(
	            'div',
	            { className: 'portofolio-project laminar ' },
	            _react2.default.createElement(
	                'h1',
	                null,
	                ' Demo Application for Laminar Data'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'project-subtitle' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'project-status' },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        'Status: '
	                    ),
	                    ' Completed'
	                )
	            ),
	            _react2.default.createElement('img', { src: mockImg, alt: 'laminar Screenshots' }),
	            _react2.default.createElement(
	                'div',
	                { className: 'project-section project-intro' },
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Introduction'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'In this project, 3 other student and I developed an application to increase the business value of a software service owned by our industrial customer. The company, Snow\uFB02ake Software, attempts to use our application project as a pitching demo application to potential clients. For this to occur, the application is supposed to provide innovative solutions and visualizations of the information offered through an API by the company, namely aviation data. We indulged into producing and displaying a number of representation ideas, some of which were very well received by our customer. We targeted a large number of stakeholders and attempted to cover all the types of data that the Snow\uFB02ake\u2019s API exposes. The \uFB01nal application relies on a decoupled architecture design that was split into a back-end server and a front-end client, which is easily maintainable and thoroughly tested. The end product we delivered was very positively appreciated by the industrial customer who was very satis\uFB01ed with the project\u2019s outcome, as can be seen in the recommendation letter they offered. The application is soon to be used for its true production purpose, namely as a selling point for Snow\uFB02ake\u2019s services.',
	                    _react2.default.createElement('br', null),
	                    'I was responsible with the design and development of the web application, while the other 3 students worked on the backend application.',
	                    _react2.default.createElement('br', null),
	                    ' ',
	                    _react2.default.createElement('br', null),
	                    'This project was part of the disseration submitted for the award of Master\'s degree in Computer Science from University of Southampton.',
	                    _react2.default.createElement('br', null),
	                    'The software was developed in 4 months, during my 3rd university year (October 2016 - January 2017).',
	                    _react2.default.createElement('br', null),
	                    'A recommendation letter written by our customer is available ',
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'https://drive.google.com/file/d/1QwUtDXL-IKGkxoQilDHmlQmRvmCVTYiY/view?usp=sharing', target: '_blank' },
	                        ' here'
	                    ),
	                    '.',
	                    _react2.default.createElement('br', null),
	                    'The full report of the project is available ',
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'https://drive.google.com/file/d/1sm0MawNCYSSZSlZ39psZMjY6EhCejEsv/view?usp=sharing', target: '_blank' },
	                        ' here'
	                    ),
	                    '.'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'project-tags' },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        '#AngularJS'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        '#Flask'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        '#Heroku'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        '#AgileDevelopment'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'project-section project-architecture' },
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Architecture '
	                ),
	                _react2.default.createElement('img', { src: architectureImg, alt: 'laminar Architecture' })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'project-section project-features' },
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Achievements'
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    null,
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement('i', { className: 'fa fa-check' }),
	                        'Work closely with an industrial customer to satisfy their requirements'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement('i', { className: 'fa fa-check' }),
	                        'Follow Agile Software Development principles'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement('i', { className: 'fa fa-check' }),
	                        'Come up with innovative ways to display data'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement('i', { className: 'fa fa-check' }),
	                        'Integrate the frontend aplpication with a backend application developed by somebody else '
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement('i', { className: 'fa fa-check' }),
	                        'Write unit tests, integration tests'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement('i', { className: 'fa fa-check' }),
	                        'Use Google Maps SDK'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'project-section project-screenshots' },
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Screenshots'
	                ),
	                _react2.default.createElement(_gallery2.default, { images: screenshots })
	            )
	        )
	    );
	};
	
	exports.default = laminarPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-portofolio-laminar-js-2a86cd64c9d71356b59a.js